const ELEMENT_NAME = "compare-section";

const attributes = {
  root: `data-${ELEMENT_NAME}`,
  toggle: `data-${ELEMENT_NAME}-toggle`,
  column: `data-${ELEMENT_NAME}-column`,
  column_header: `data-${ELEMENT_NAME}-column-header`,
  column_header_wrapper: `data-${ELEMENT_NAME}-column-header-wrapper`,
  column_title: `data-${ELEMENT_NAME}-column-title`,
  list_item: `data-${ELEMENT_NAME}-list-item`,
  product_id: `data-${ELEMENT_NAME}-product-id`,
  target: `data-${ELEMENT_NAME}-target`,
  index: `data-${ELEMENT_NAME}-index`,
};

class DetailsSelect extends HTMLElement {
  connectedCallback() {
    const toggle = this.querySelector(`[${attributes.toggle}]`);
    if(toggle){
      toggle.addEventListener("click", e=>{
        e.target.closest(`[${attributes.root}]`)?.classList.toggle("js-model");
      });
    }
    [...this.querySelectorAll(`[${attributes.column_header}]`)].forEach(el=>{
      el.addEventListener("click", this.handle_dropdowns.bind(this));
    });
  }
  handle_dropdowns(e){
    if(e.target.hasAttribute(`${attributes.column_title}`)){
      e.target.closest(`[${attributes.column_header_wrapper}]`)?.classList.toggle("js-active");
    }else if(e.target.hasAttribute(`${attributes.list_item}`)){
      const current_column = e.target.closest(`[${attributes.column}]`);
      const current_id = current_column.getAttribute(`${attributes.product_id}`);
      const new_id = e.target.getAttribute(`${attributes.target}`);
      const target_column = this.querySelector(`[${attributes.column}][${attributes.product_id}="${new_id}"]`);
      if(target_column && current_column){
        const index = current_column.getAttribute(`${attributes.index}`);
        current_column.removeAttribute(`${attributes.index}`);
        target_column.setAttribute(`${attributes.index}`, index);
        target_column.querySelector(`[${attributes.column_header_wrapper}]`)?.classList.remove("js-active");
        // Update old list item from dropdowns
        [...this.querySelectorAll(`[${attributes.list_item}][${attributes.target}="${current_id}"]`)].forEach(item=>{
          item.classList.remove("js-disabled");
        });
        // update new list item from dropdowns
        [...this.querySelectorAll(`[${attributes.list_item}][${attributes.target}="${new_id}"]`)].forEach(item=>{
          item.classList.add("js-disabled");
        });
      }
    }
  }
}

if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(ELEMENT_NAME, DetailsSelect);
}